// extracted by mini-css-extract-plugin
export var readonly = "_gb-1";
export var star = "_gb-0";